// import React from "react";
// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";
// const RouteGuard = ({ children, isProtected }) => {
//   const { userInfo, token } = useSelector((state) => state.auth);
  
//   const storedUserInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
//   const isAuthenticated = (userInfo || storedUserInfo) && (token);
//   // if (isProtected && !isAuthenticated) {
//   //   return <Navigate to="/" replace />;
//   // }
//   if (!isProtected && isAuthenticated) {
//     return <Navigate to="/dashboard" replace />;
//   }
//   return children;
// };
// export default RouteGuard;




// src/components/RouteGuard.jsx
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const RouteGuard = ({ children, isProtected }) => {
  const { userInfo, authReady } = useSelector((state) => state.auth);
  const location = useLocation();

  const isAuthenticated = Boolean(userInfo);
  const isFinkedaCallback = String(location.pathname || "").includes("/payment/callback");

  if (isFinkedaCallback) {
    return children;
  }

  if (!authReady) return null;

  if (isProtected && !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isProtected && isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RouteGuard;